export enum ChatRuleTypeEnum {
  "No_Contact_Information" = 1,
  "Professional_Language" = 2,
  "External_Platform_Links" = 3,
  "Spam_and_Repetitive_Messages_Filter" = 4,
  "Sensitive_Content_Filter" = 5,
  "Chat_Message_Limit" = 6,
  "External_Deal_Detection" = 7,
  "File_Attachment_Filter" = 8,
  "Role_Based_Contextual_Rules" = 9,
}

export enum ChatRuleStatusEnum {
  "Active" = 1,
  "Inactive" = 2,
}

export enum ChatRuleEnum {
  // Default values
  DEFAULT_TYPE = ChatRuleTypeEnum.No_Contact_Information,
  DEFAULT_STATUS = ChatRuleStatusEnum.Active,
}
